<template>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-2 h-fit">
        <StatNumberTrend v-for="item in statistics" :item="item"/>
    </div>
</template>

<script>
import StatNumberTrend from "./StatNumberTrend";
export default {
    name: "Stats",
    components: {StatNumberTrend},
    data(){
        return {
            statistics: this.$page.props.statistics
        }
    }
}
</script>

<style scoped>

</style>
